import { DocumentRequestsStateModel } from './document-requests.state';

import { Selector } from '@ngxs/store';
import { DocumentRequestsState } from './document-requests.state';
import { DocumentRequest } from '@models/document-requests';

export class DocumentRequestsSelectors {
	@Selector([DocumentRequestsState])
	static getDocumentRequests(
		state: DocumentRequestsStateModel,
	): DocumentRequest[] {
		return state?.items
			? [...state.items].sort((a, b) => b.createdAt - a.createdAt)
			: [];
	}

	@Selector([DocumentRequestsState])
	static getDocumentRequestById(
		state: DocumentRequestsStateModel,
	): (id: string) => DocumentRequest {
		return (id: string) => state?.items?.find((item) => item.id === id);
	}
}
